import { useAppQuery } from "../../http/useAppQuery.ts";
import type { WorkspaceDetails } from "../types.ts";
import { useWorkspaceUuid } from "./useWorkspaceUuid.ts";

export const useWorkspaceDetails = ({
  enabled = true,
}: {
  enabled?: boolean;
}) => {
  const workspaceUuid = useWorkspaceUuid();
  const detailsQuery = useAppQuery<WorkspaceDetails>({
    queryKey: `workspaces/${workspaceUuid}/details`,
    enabled,
  });

  return {
    details: detailsQuery.data,
    isLoading: detailsQuery.isLoading,
  };
};
